import * as React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  position: relative;
  display: block;
  padding-top: 7px;
`;
const StyledLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 20px;
  font-weight: normal;
  cursor: pointer;
  margin-bottom: 0;

  input[type='radio'] {
    margin-top: 1px;
  }
`;
const Radio = ({
  "aria-describedby": ariaDescribedBy = void 0,
  "aria-label": ariaLabel = void 0,
  "aria-labelledby": ariaLabelledBy = void 0,
  checked = void 0,
  children = void 0,
  className = void 0,
  defaultChecked = void 0,
  disabled = false,
  id = void 0,
  name = void 0,
  onChange,
  title = void 0,
  value = void 0
}, ref) => /* @__PURE__ */ React.createElement(Wrapper, { className }, /* @__PURE__ */ React.createElement(StyledLabel, { htmlFor: id, title }, /* @__PURE__ */ React.createElement(
  "input",
  {
    ref,
    type: "radio",
    id,
    name,
    value,
    checked,
    defaultChecked,
    disabled,
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    onChange
  }
), children));
export default React.forwardRef(Radio);
